import React from "react"
import { Card, CardBody } from "reactstrap"
import PropTypes from "prop-types"
import LeasePayments from "./LeasePayments"

const LocationLeasePaymentsCard = ({ payments, leaseAmount, locationId, operation_hours, handleSave }) => {
    return (
        <Card style={{ backgroundColor: "#3C3C3C", border: "none" }}>
            <CardBody>
                <LeasePayments
                    location_id={locationId}
                    lease_amount={leaseAmount}
                    operation_hours={operation_hours}
                    payments={payments}
                    handleSave={handleSave}
                />
            </CardBody>
        </Card>
    )
}

LocationLeasePaymentsCard.propTypes = {
    payments: PropTypes.array,
    leaseAmount: PropTypes.any,
    locationId: PropTypes.any,
    onSave: PropTypes.func
}

export default LocationLeasePaymentsCard